import React from 'react'
import { Btn, CustomDataTableHeader } from '../../../../../../components'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { gerarArquivoExcel } from '../../../../../../services/util/excel.service'
import { formatDateToLocale } from '../../../../../../services/util/date.service'
import '../../../../Picking/HistoricoLeitura/TabHistorico.css'

const formatDateTime = value => {
  if (!value || value === '-') return '-'

  try {
    return formatDateToLocale(value, 'dd/MM/yy HH:mm:ss').toFormat('dd/MM/yy HH:mm:ss')
  } catch (e) {
    return '-'
  }
}

const EXCEL_COLUMNS = [
  { header: 'Horário Exclusão', get: b => b.horario_exclusao },
  { header: 'Horário Bip', get: b => b.horario },
  { header: 'Produto', get: b => b.produto },
  { header: 'Vol', get: b => b.vol },
  { header: 'Uni', get: b => b.uni },
  { header: 'Estoque', get: b => b.estoque },
  { header: 'Posição', get: b => b.posicao },
  { header: 'Bipado Por', get: b => b.bipado_por },
  { header: 'Excluído Por', get: b => b.excluido_por },
  { header: 'Código Ativação', get: b => b.codigo_ativacao },
]

const TabBipsExcluidosExpedicao = ({ bips }) => {
  const [globalFilter, setGlobalFilter] = React.useState('')

  return (
    <div className="p-grid p-col-12">
      <div className="p-col-12">
        <Btn
          onClick={() => {
            const data = [EXCEL_COLUMNS.map(c => c.header)]
            bips.forEach(b => {
              data.push(EXCEL_COLUMNS.map(c => c.get(b)))
            })
            gerarArquivoExcel('BIPs Excluídos', data, 'bips_excluidos_expedicao.xlsx')
          }}
        >
          Exportar
        </Btn>
      </div>
      <div className="p-col-12 p-datatable-responsive">
        <DataTable
          value={bips}
          emptyMessage={'Não existem BIPs excluídos'}
          header={
            <div style={{ width: '100%', height: 50 }}>
              <CustomDataTableHeader onChange={setGlobalFilter} />
            </div>
          }
          globalFilter={globalFilter}
          rows={15}
          paginator={true}
          responsive={true}
        >
          <Column
            field={'horario_exclusao'}
            header={'Horário Exclusão'}
            className="column-responsive"
            style={{ width: '150px' }}
            body={bip => formatDateTime(bip.horario_exclusao)}
          />
          <Column
            field={'produto'}
            header={'Produto'}
            className="column-responsive column-important"
          />
          <Column field={'vol'} header={'Vol'} className="column-number" style={{ width: '80px' }} />
          <Column field={'uni'} header={'Uni'} className="column-number" style={{ width: '80px' }} />
          <Column
            field={'estoque'}
            header={'Estoque'}
            className="column-responsive"
            style={{ width: '120px' }}
          />
          <Column
            field={'posicao'}
            header={'Posição'}
            className="column-responsive"
            style={{ width: '120px' }}
          />
          <Column
            field={'bipado_por'}
            header={'Bipado Por'}
            className="column-responsive md-hide"
          />
          <Column
            field={'excluido_por'}
            header={'Excluído Por'}
            className="column-responsive"
            style={{ width: '160px' }}
          />
          <Column
            field={'codigo_ativacao'}
            header={'Código Ativação'}
            className="column-responsive"
            style={{ width: '140px' }}
          />
        </DataTable>
      </div>
    </div>
  )
}

export default TabBipsExcluidosExpedicao
